import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ComponentAction} from "../../models/component-action";
import Helpers from "../../utils/helpers";

@Injectable()
export class ComponentActionControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  // deprecated
  public getById(id: string): Observable<ComponentAction> {
    return this.http.get(this.baseUrl + "componentactions/" + id) as Observable<ComponentAction>;
  }

  // deprecated
  public saveComponentActions(serviceId: string, key: string, componentActions: ComponentAction[]) {
    const body = JSON.stringify(componentActions);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/componentaction/" + key, body, {responseType: "text"});
  }

  public getComponentAction(serviceId: string, key: string): Observable<ComponentAction> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/componentactions/" + key) as Observable<ComponentAction>;
  }

  public save(id: string, componentActions: ComponentAction): Observable<ComponentAction>  {
    Helpers.trimRecursiveObj(componentActions);
    const body = JSON.stringify(componentActions);
    return this.http.put(this.baseUrl + "componentactions/" + id, body) as Observable<ComponentAction> ;
  }

  public saveComponentAction(serviceId: string, key: string, componentActions: ComponentAction): Observable<ComponentAction>  {
    Helpers.trimRecursiveObj(componentActions);
    const body = JSON.stringify(componentActions);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/componentactions/" + key, body) as Observable<ComponentAction> ;
  }

  public deleteComponentActions(serviceId: string, componentKey: string) {
    return this.http.delete(this.baseUrl + "service/" + serviceId + "/componentactions/" + componentKey, { responseType: "text" });
  }
}
